export default __webpack_public_path__ + "static/media/543.a45c7547.png";